<template>
  <div
    v-show="isToolbarVisible"
    class="content-slide-toolbar-wrp"
    id="content-slide-toolbar-wrp"
    :class="{'is-editing-text-block': slideActive.isEditingTextBlock}"
  >
    <div class="freestyle-actions-wrapper" v-if="slideActive.type === 'freestyle' && !isPresenting">
      <div
        class="freestyle-editor-toolbar"
        id="freestyle-editor-toolbar"
        :class="{'hidden': !isFreestyleEditorToolbarVisible,
                 'z-5': isFreestyleEditorToolbarVisible,
        }"
      />
      <div
        class="freestyle-actions bg-primary-20"
        :class="{'z-4': !isFreestyleEditorToolbarVisible,
                 'hidden': slideActive.isEditingTextBlock || isFreestyleEditorToolbarVisible,
                 'has-box-shadow': !isShapeOrLineActionsVisible }"
      >
        <div class=" my-1" v-if="isShowImproveWritingDropDown">
          <ImprovedWritingDropDown />
        </div>
        <div class="divider" v-if="isShowImproveWritingDropDown" />
        <a
          class="freestyle-action"
          @click="addCanvasBlock('RichText')"
          v-tooltip="$i18nPresenter.t('Text')"
          :class="{'hidden': isShapeOrLineActionsVisible}"
        >
          <aha-icon
            name="text"
            width="24"
            height="24"
            viewBox="0 0 24 24"
          />
        </a>
        <a
          class="freestyle-action"
          @click="addCanvasBlock('Image')"
          v-tooltip="$i18nPresenter.t('Image')"
          :class="{'hidden': isShapeOrLineActionsVisible}"
        >
          <aha-icon
            name="image"
            width="24"
            height="24"
            viewBox="0 0 24 24"
          />
        </a>
        <a
          class="freestyle-action __gif"
          @click="addCanvasBlock('GIF')"
          v-tooltip="$i18nPresenter.t('Animated GIF')"
          :class="{'hidden': isShapeOrLineActionsVisible}"
        >
          <video
            width="24"
            height="24"
            id="content-slide-gif-icon"
            autoplay
            loop="true"
            muted
            playsinline
          >
            <source :src="gifWebm" type="video/webm">
            {{ $i18nPresenter.t('Your browser does not support the video tag.') }}
          </video>
        </a>
        <a
          class="freestyle-action emoji-action"
          id="emoji-trigger"
          @mouseenter="onMouseEnterEmoji"
          @mouseleave="isShowEmojiTooltip = false"
          @click="openEmojiSelector"
          v-tooltip="emojiTooltip"
          v-click-outside="closeEmojiSelector"
          :class="{'hidden': isShapeOrLineActionsVisible}"
        >
          <font-awesome-icon
            :icon="['far', 'smile-wink']"
            size="lg"
            class="smile-icon"
          />
          <div
            id="emoji-selector"
            @click.stop="() => {}"
            @mouseenter.stop="isShowEmojiTooltip = false"
          ></div>
        </a>
        <a
          id="shape-trigger"
          class="freestyle-action shape-action relative"
          @mouseenter="onMouseEnterShapeTrigger"
          @mouseleave="onMouseLeaveShapeTrigger"
          @click="openShapeSelector"
          v-click-outside="closeShapeSelector"
          v-tooltip="shapeTooltip"
          :class="{'hidden': isShapeOrLineActionsVisible}"
        >
          <aha-icon
            name="shape"
            width="24"
            height="24"
            viewBox="0 0 20 20"
          />
          <div v-show="isShowShapeSelector" class="absolute top-10 left-0 rounded bg-transparent">
            <ShapeSelector
              v-show="isShowShapeSelector"
              @onShapeSelect="onShapeSelect"
              @onLineSelect="onLineSelect"
            />
          </div>

        </a>
        <div class="divider">
        </div>
        <div>
          <AnimationToolbar
            :is-topbar="true"
            :selectingBlocks="selectingBlocks"
          />
        </div>

        <div v-if="isShowShapeEditorToolbar" class="w-max h-full absolute top-0 left-0 z-5">
          <ShapeEditorToolbar />
        </div>
        <div v-if="isShowLineEditorToolbar" class="w-max h-full absolute top-0 left-0 z-5">
          <LineEditorToolbar />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import { Picker } from 'emoji-mart'
import EventBus from '@/eventBus'
import LineEditorToolbar from './LineEditorToolbar.vue'
import ShapeSelector from './editors/ShapeSelector.vue'
import LineEditorMixin from '@/mixins/freestyle/LineEditorMixin.js'
import utils from '@/util'
import eventCategories from '@/constant/eventCategories'
import gifIcon from '@/assets/animations/gif.webm'
import config from '@/config'
import ShapeEditorToolbar from './ShapeEditorToolbar.vue'
import AnimationToolbar from '@/components-v2/presentation-editor/middle/AnimationToolbar.vue'
import ActiveTabNames from '@/constant/ActiveTabNames'
import ImprovedWritingDropDown from '@/components-v2/presentation-editor/freestyle/ImproveWritingDropDown.vue'

const CREATE_BLOCK = 'create-block'

export default {
  components: {
    ImprovedWritingDropDown,
    AnimationToolbar,
    // AnimationEditor,
    LineEditorToolbar,
    ShapeEditorToolbar,
    ShapeSelector,
  },
  mixins: [LineEditorMixin],
  data() {
    return {
      showFreestyleEditorToolbar: false,
      isShowEmojiTooltip: false,
      gifWebm: gifIcon,
      allowShowSlideType: [
        'freestyle',
        'textSlide',
        'image',
      ],
      isShowShapeTooltip: false,
      isShowShapeSelector: false,
      isShowLineSelector: false,
      isShowAnimationEditor: false,
    }
  },
  computed: {
    ...mapGetters(['isBackstage', 'isPresenting']),
    ...mapGetters('rightNav', ['rightNavTabNames']),
    ...mapGetters('aiAutoImproveSlideContent', ['canUseAIImproveDirectly']),
    ...mapState({
      isDisableEditPresentation: (state) => state.isDisableEditPresentation,
      canEditPresentation: (state) => state.canEditPresentation,
      slideActive: (state) => state.slideActive,
      selectingBlocks: (state) => state.selectingBlocks,
      presentation: (state) => state.presentation,
      isEnableAddinPowerpoint: (state) => state.isEnableAddinPowerpoint,
    }),
    isShowImproveWritingDropDown() {
      return this.canUseAIImproveDirectly && !this.isShapeOrLineActionsVisible
    },
    isShowLineEditorToolbar() {
      return this.selectingBlocks && ((
        this.selectingBlocks.length === 1 &&
        this.selectingBlocks[0].type === 'Line')
       || (
         this.selectingBlocks.length > 1 &&
        this.selectingBlocks.every((block) => block.type === 'Line')
       ))
    },

    isShowShapeEditorToolbar() {
      return this.selectingBlocks &&
        this.selectingBlocks.length &&
        this.selectingBlocks[0].type === 'Shape'
    },

    isSelectingTextBlocks() {
      return this.selectingBlocks &&
        this.selectingBlocks.length &&
        this.selectingBlocks.some((block) => block.type === 'RichText')
    },

    slideTypesAllowToolbar() {
      if (this.allowShowSlideType.includes(this.slideActive.type)) return true
      if (this.isEnableAddinPowerpoint) return true
      return false
    },

    isEURegion() {
      return config.region === 'eu'
    },

    isToolbarVisible() {
      return !this.isBackstage &&
      ((this.canEditPresentation && this.slideTypesAllowToolbar) || this.isEURegion)
    },
    isFreestyleEditorToolbarVisible() {
      return this.slideActive.type === 'freestyle' &&
        !this.isDisableEditPresentation &&
        this.showFreestyleEditorToolbar
    },
    emojiTooltip() {
      return {
        show: this.isShowEmojiTooltip,
        content: 'Emoji',
      }
    },
    shapeTooltip() {
      return {
        show: this.isShowShapeTooltip && !this.isShowShapeSelector,
        content: 'Shape',
      }
    },
    lineTooltip() {
      return {
        content: 'Line',
      }
    },
    slideTypeInPPTAddIn() {
      if (this.slideActive && ['spinnerWheel'].includes(this.slideActive.type)) {
        return true
      }
      return false
    },
    isShapeOrLineActionsVisible() {
      return this.isShowShapeEditorToolbar || this.isShowLineEditorToolbar
    },
  },
  mounted() {
    EventBus.$on('show-freestyle-editor-toolbar', this.onShowFreestyleEditorToolbar)
  },
  destroyed() {
    EventBus.$off('show-freestyle-editor-toolbar')
    this.isShowEmojiTooltip = false
  },
  methods: {
    ...mapActions(['updateSlideActiveAction', 'setSelectedTabAction']),
    ...mapActions('rightNav', ['setRightNavActiveTabAction']),

    onShowFreestyleEditorToolbar(value) {
      this.showFreestyleEditorToolbar = value
    },

    addCanvasBlock(type, value) {
      if (type === 'RichText') {
        EventBus.$emit(CREATE_BLOCK, 'RichText')
      } else if (type === 'Image') {
        EventBus.$emit(CREATE_BLOCK, 'Image')
        this.setSelectedTabAction(ActiveTabNames.UPLOAD)
      } else if (type === 'GIF') {
        EventBus.$emit(CREATE_BLOCK, 'Image')
        this.setSelectedTabAction(ActiveTabNames.GIPHY)
      } else if (type === 'Shape') {
        EventBus.$emit(CREATE_BLOCK, 'Shape', value)
      }
    },
    onMouseEnterEmoji() {
      this.isShowEmojiTooltip = true
    },
    openEmojiSelector() {
      const self = this
      if (!this.emojiPicker) {
        this.emojiPicker = new Picker({
          set: 'native',
          onEmojiSelect: self.onEmojiSelect,
        })
        document.getElementById('emoji-selector').appendChild(this.emojiPicker)
        this.isShowEmojiTooltip = false
      }
    },
    onMouseEnterShapeTrigger() {
      this.isShowShapeTooltip = true
    },
    onMouseLeaveShapeTrigger() {
      this.isShowShapeTooltip = false
    },
    onShapeSelect(e) {
      EventBus.$emit(CREATE_BLOCK, 'Shape', e)
      this.closeShapeSelector()
    },

    onLineSelect(lineType) {
      EventBus.$emit(CREATE_BLOCK, 'Line', lineType)
      this.closeShapeSelector()
    },
    openShapeSelector() {
      this.isShowShapeTooltip = false
      this.isShowShapeSelector = true
    },

    onEmojiSelect(e) {
      EventBus.$emit(CREATE_BLOCK, 'Emoji', e)
      this.closeEmojiSelector()
    },
    closeEmojiSelector() {
      this.emojiPicker = null
      const selectorRef = document.getElementById('emoji-selector')

      if (selectorRef) {
        selectorRef.innerHTML = ''
      }
    },
    closeShapeSelector() {
      this.isShowShapeSelector = false
    },
    closeAnimationEditor() {
      this.isShowAnimationEditor = false
    },
    handleOpenImageModal() {
      this.setRightNavActiveTabAction(this.rightNavTabNames.DESIGN)
      setTimeout(() => {
        EventBus.$emit('open-modal-upload-image2', 'gif')
      }, 250)
      utils.mixpanelTracking(
        eventCategories.PRESENTATION_EDITOR,
        'Content slide toolbar > GIF',
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.content-slide-toolbar-wrp {
  height: 36px;
  min-height: 36px;
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 12px 0;
  &.is-editing-text-block {
    margin: 10px 0 14px;
    .freestyle-editor-toolbar::v-deep .tox.tox-tinymce.tox-tinymce-inline {
      border-bottom: 1px solid #ccc;
    }
  }
  &.is-other-slide-types {
    display: flex;
    @apply bg-base-0 items-center justify-between px-5;
  }
}
.freestyle-actions-wrapper {
  position: relative;
  min-width: 236px;
}

.freestyle-editor-toolbar {
  width: 100%;
  & +.slide-intro {
    padding-top: 10px;
  }
  &::v-deep button.tox-tbtn.tox-tbtn--select[title="Font sizes"] {
    width: 70px !important;
  }
  &::v-deep button.tox-tbtn.tox-tbtn--select[title="Fonts"] {
    width: 150px !important;
  }

  &::v-deep button.disabled[title='Insert/edit link']{
    &:active{
      pointer-events: none;
    }
    cursor: not-allowed;
  }
  &::v-deep .tox.tox-tinymce.tox-tinymce-inline
  &::v-deep .tox-tinymce-inline .tox-editor-header {
    height: 40px;
    border: none;
  }
  &::v-deep .tox-toolbar-overlord {
    height: 40px;
  }
  &::v-deep .tox-toolbar__primary {
    background: none;
    height: 40px;
  }
  &::v-deep .tox:not([dir=rtl]) .tox-toolbar__group:not(:last-of-type) {
    border-right: 1px solid #eee;
  }
}

.freestyle-actions {
  width: max-content;
  height: 36px;
  min-height: 36px;
  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: 8px;
  background: #fff;
  &.has-box-shadow {
    box-shadow: 0px 1px 3px 0px #0A0A0A1A;
  }
  &.hidden {
    position: absolute;
    top: 0;
    margin: 12px 0;
    z-index: -1;
  }
  .freestyle-action {
    z-index: 4;
    cursor: pointer;
    display: flex;
    margin-right: 4px;
    color: #222;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    padding: 4px;
    &:last-child {
      margin-right: 2px;
    }
    &:first-child {
      margin-left: 2px;
    }
    &:hover {
      @apply bg-secondary-15;
    }
    &.__gif {
      margin-bottom: -0.75px;
    }
    &.emoji-action {
      position: relative;
    }
    &.hidden {
      display: none;
    }
  }

}
.smile-icon {
  width: 24px;
  height: 24px;
  padding-top: 2px;
  padding-bottom: 2px;
}

#emoji-selector {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
}
.divider{
  width: 2px;
  background: #eee;
  height: 45%;
  margin-right: 8px;
  margin-left: 8px;
}
</style>
